var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTest)?_c('div',{staticClass:"environment"},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.envName)+" ")]),_c('p',[_c('strong',[_vm._v("Адрес:")]),_vm._v(" "+_vm._s(_vm.host)+" ")]),_c('p',[_c('strong',[_vm._v("API:")]),_vm._v(" "+_vm._s(_vm.apiHost)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }